// @flow

import GroupsIcon from "@mui/icons-material/Groups";
import { Card, CardContent, Typography } from "@mui/material";
import React from "react";

type Props = {

};

const Kpi = (props: Props) => {
	const {icon, iconColor, title, children} = props
	const Icon = icon
	return (
		<Card sx={{ display: 'flex', alignItems: 'center', p: 2, borderRadius: 3 }}>
			<Icon sx={{ fontSize: 40, mr: 2, color: iconColor }}/>
			<CardContent>
				<Typography variant="h6" color="text.secondary">
					{title}
				</Typography>
				<Typography variant="h4" color="text.primary">
					{children}
				</Typography>
			</CardContent>
		</Card>
	);
};

export default Kpi